// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"e9ad4e5a","243":"6e5bf196","374":"0b8ca12a","393":"4f793a14","453":"f9d06b21","681":"d3de9dea","848":"ff62a809","876":"ed2f02bd"}[chunkId] + ".chunk.js";
};